import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import DocumentTemplateModel from '../../../models/DocumentTemplateModel';
import DataService from "../../../services/data.service";
import AddDocumentTemplatePopup from '../Popups/AttachmentType_popup_AddDocumentTemplate';

interface Props {
    attachmentTypeId: number
}

const AttachmentType_tab_DocumentTemplates: React.FC<Props> = ({ attachmentTypeId }) => {
    const [data, setData] = useState<DocumentTemplateModel[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();

    useEffect(() => {
        getTableData();
    }, [attachmentTypeId]);

    function getTableData() {
        DataService.get<DocumentTemplateModel[]>('api/v1/DocumentTemplates/ByAttachmentType/' + attachmentTypeId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData: DocumentTemplateModel) {
        DataService.delete('api/v1/DocumentTemplates/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'Id', visible: false },
        { title: 'Name', dataProp: 'name', sort: 'asc' },
        { title: 'Language', dataProp: 'language' },
        { title: 'Output type', dataProp: 'documentOutputType.name' },
        { title: 'Active', dataProp: 'isActive', dataType: 'bool' },
    ];

    const { isAuthorizedFor } = useAuth();
    if (isAuthorizedFor(ApplicationFunctions.UpdateBusinessPartner)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            }
        );
    }

    return (
        <>
            <DataTable
                name='dtAttachmentTypeDocumentTemplates'
                colInfos={colInfos}
                tableData={data}
            />
            {showPopup && <AddDocumentTemplatePopup attachmentTypeId={attachmentTypeId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />}
        </>
    );
}
export default AttachmentType_tab_DocumentTemplates;